import React, {useRef, useLayoutEffect} from 'react';
import { ReactComponent as ArrowDownIcon } from '../../assets/img/icons/en-flag.svg';
import { translate } from '../../selectors/translations';
import { FilterChangedData } from '../../store/Patients/types';
interface DropdownItem {
  title: string;
  isSelected: boolean;
  propToPropagate?: string;
}

interface SelectorBoxProps {
  items: DropdownItem[];
  type: string;
  dropdownId: string;
  Elem: React.ReactElement;
  onSelect?: (val: FilterChangedData) => void;
  onToggleMenu: (id: string) => void;
}

const SelectorBox: React.FC<SelectorBoxProps> = (props: SelectorBoxProps) => {
  const { dropdownId, items, type, Elem, onToggleMenu} = props;
  const node: any = useRef<HTMLDivElement>(null);

  const handleClickOutside = (e: Event): void => {
    if (!node.current.contains(e.target)) {
      // outside click
      onToggleMenu('')
      return;
    }
  }

  useLayoutEffect(() => {
    if (dropdownId && (dropdownId === type)) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return (): void => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownId]);

  let selectedValue: null | string = null;
  try {
    selectedValue = items.filter((i: DropdownItem) => i.isSelected)[0].title
  } catch (e) {
    selectedValue = null
  }
  return (
    <div ref={node} className="selector-box">
      <div className="selector_selected-block" onClick={(): void => onToggleMenu(type === dropdownId ? '' : type)}>
        <div className="part ellipsis"><span>{translate(selectedValue ? selectedValue : '')}</span></div>
        <div className="part"><ArrowDownIcon /></div>
      </div>
      { (type === dropdownId) && Elem }
    </div>
  );
}

export default SelectorBox;
